import {Component, OnInit} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';
import {AdminService} from 'src/app/services/admin.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-metadata',
  templateUrl: './metadata.component.html',
  styleUrl: './metadata.component.css'
})
export class MetadataComponent implements OnInit {
  mobileQuery: MediaQueryList;
  objectsToRTDBForm: FormGroup;

  constructor(
    media: MediaMatcher,
    private adminservice: AdminService,
    private fb: FormBuilder,
  ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  ngOnInit(): void {
    // Initialize the form group
    this.objectsToRTDBForm = this.fb.group({
      objectsToRTDB: ['', Validators.required]
    });
  }

  async onObjectsToRTDBClick(projectId: string) {
    await this.adminservice.updateObjectsToRTDB(projectId);
  }

}
